import StatusColorful from "../../../Components/Table/Components/StatusColorful";

const displayOptionalValue = (value) =>
  value === null ||
  value === undefined ||
  String(value).trim() === "" ||
  String(value).trim() === "-"
    ? "ندارد"
    : value;

export default function FriendsGridCard({
  name,
  challenge,
  challengePrice,
  commissionPercent,
  commissionAmount,
  status,
}) {
  const statusProps = {
    paid_out: { text: "برداشت شده", color: "blue" },
    pending: { text: "در انتظار", color: "yellow" },
    can_payout: { text: "قابل برداشت", color: "green" },
  }[status] ?? { text: "نامشخص", color: "gray" };

  return (
    <article className="w-full rounded-2xl p-2.5 flex flex-col gap-3 bg-gradient-to-br from-white/10 to-white/5 border border-white/10">
      <div className="w-full flex items-start justify-between gap-2.5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            نام
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
            {displayOptionalValue(name)}
          </span>
        </div>
        <StatusColorful
          text={statusProps.text}
          className="w-fit"
          color={statusProps.color}
          containerClassName="!w-fit"
        />
      </div>
      <div className="w-full flex items-center justify-between gap-2.5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            چالش
          </span>
          <span className="text-xs text-zi-text-light/75 dark:text-zi-text-dark/75">
            {displayOptionalValue(challenge)}
          </span>
        </div>
        <div className="flex flex-col gap-0 items-end">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            قیمت چالش
          </span>
          <span className="text-xs text-zi-text-light/75 dark:text-zi-text-dark/75 [direction:ltr]">
            {displayOptionalValue(challengePrice)}
          </span>
        </div>
      </div>
      <div className="w-full flex items-center justify-between gap-2.5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            درصد کمیسیون
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark [direction:ltr]">
            {displayOptionalValue(commissionPercent)}
          </span>
        </div>
        <div className="flex flex-col gap-0 items-end">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            مبلغ کمیسیون
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark [direction:ltr]">
            {displayOptionalValue(commissionAmount)}
          </span>
        </div>
      </div>
    </article>
  );
}
